import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/QR.png'


const _withScopeId = n => (_pushScopeId("data-v-2528b3c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto p-4" }
const _hoisted_2 = { class: "step-list" }
const _hoisted_3 = { class: "step-item" }
const _hoisted_4 = { class: "step-item" }
const _hoisted_5 = { class: "step-item" }
const _hoisted_6 = { class: "step-item" }
const _hoisted_7 = { class: "step-item" }
const _hoisted_8 = { class: "step-item" }
const _hoisted_9 = { class: "step-item" }
const _hoisted_10 = { class: "list" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "QR",
  class: "w-fit mb-4 pt-4"
}, null, -1))
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "item" }

import BaseReturn from '@/components/common/BaseReturn.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HowToPay',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseReturn, {
      text: "Как заказать и оплатить",
      class: "mb-8"
    }),
    _createVNode(BaseTypography, {
      text: "Как заказать и оплатить экскурсию или тур",
      type: "subtitle2",
      color: "var(--primary-color)",
      class: "subtitle"
    }),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(BaseTypography, {
          text: "1 шаг: отправить заявку.",
          type: "body2",
          class: "subtitle"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Забронировать места на экскурсию вы можете следующим образом:",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "нажать кнопку «ЗАБРОНИРОВАТЬ» в описании экскурсии;",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "написать на почтовый адрес reserv@rvm-spb.ru;",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "отправить запрос по электронной почте info@rvm-spb.ru.",
          type: "body"
        })
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(BaseTypography, {
          text: "2 шаг: оплатить заказ.",
          type: "body2",
          class: "subtitle"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "У вас есть 2 способа сделать это:",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Удалённо, через различные системы оплат. После бронирования и выбора способа оплаты специалист вышлет вам подробную информацию по дальнейшем действиям.",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Подъехать заранее к нам в офис и оплатить наличными или по картам VISA, Mastercard, МИР. Наш офис в Бизнес центре 'Петровский форт', Финляндский проспект 4А, офис 201",
          type: "body"
        })
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(BaseTypography, {
          text: "Способы оплаты удаленно:",
          type: "body2",
          class: "subtitle"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "1) С помощью банковских карт VISA, Mastercard, МИР. Для того, чтобы оплатить с помощью банковской карты, необходимо указать свой адрес электронной почты (либо при составлении заявки, либо при заявке по телефону). На указанный адрес наш специалист отправит вам ссылку, пройдя по которой, вы сможете оплатить экскурсию или тур. После оплаты информация по заказу будет отправлена на этот же адрес — или же в виде смс-сообщения на телефон.",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "2) Используя банковские реквизиты туроператора ООО 'РВМ'. При выборе этого способа оплаты на указанный в заявке способ связи придет счет с суммой к оплате. После его получения необходимо оплатить счет, используя банковские реквизиты компании. Полученный чек нужно прислать на почту info@rvm-spb.ru.",
          type: "body"
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(BaseTypography, {
          text: "Сроки оплаты экскурсии",
          type: "body2",
          class: "subtitle"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Бронирование экскурсии должно быть оплачено не позднее чем за 3 дня до ее проведения.",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "!Наш специалист отправит вам напоминание о крайнем сроке оплаты бронирования.",
          type: "body"
        })
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(BaseTypography, {
          text: "Сроки оплаты тура",
          type: "body2",
          class: "subtitle"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Сроки оплаты тура указываются в договоре, который заключается после подтверждении бронирования тура.",
          type: "body"
        })
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(BaseTypography, {
          text: "Условия отмены бронирования экскурсии",
          type: "body2",
          class: "subtitle"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Отмена бронирования экскурсии осуществляется не позднее чем за 7 дня до ее проведения.",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Сроки аннуляций и штрафы по сборным экскурсиям определяются индивидуально и будут прописаны в договоре. Размер штрафа равняется фактически понесенным затратам. В случае частичной аннуляции услуг указанные штрафные санкции применяются к стоимости аннулированной части услуг.",
          type: "body"
        })
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(BaseTypography, {
          text: "Условия отмены бронирования тура",
          type: "body2",
          class: "subtitle"
        }),
        _createVNode(BaseTypography, {
          tag: "p",
          text: "Условия отмены бронирования указываются в договоре, который заключается после подтверждении бронирования тура.",
          type: "body"
        })
      ])
    ]),
    _createVNode(BaseTypography, {
      text: "Банковские реквизиты",
      type: "subtitle2",
      color: "var(--primary-color)",
      class: "mb-[35px]"
    }),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(BaseTypography, {
          text: "Оплата по СБП",
          type: "body2"
        }),
        _hoisted_12,
        _createVNode(BaseTypography, {
          text: "Для оплаты отсканируйте QR-код в мобильном приложении банка или штатной камерой телефона",
          type: "body"
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(BaseTypography, {
          text: "СБЕРБАНК",
          type: "body2"
        }),
        _createVNode(BaseTypography, {
          text: "Получатель: ООО «РВМ»",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "ОГРН: 1157847393373",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "ИНН: 7840042552 КПП: 780201001",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "Банковские реквизиты: Северо-Западный банк ПАО «Сбербанк»",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "Р/с: 40702810655000057947",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "К/с: 30101810500000000653",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "БИК: 044030653",
          type: "body"
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(BaseTypography, {
          text: "Т-БАНК (Возможна оплата по QR кредитками)",
          type: "body2"
        }),
        _createVNode(BaseTypography, {
          text: "Получатель: ООО «РВМ»",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "ОГРН: 1157847393373",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "ИНН: 7840042552 КПП: 780201001",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "Банковские реквизиты: АО «ТБанк»",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "Р/с: 40702810610001844787",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "К/с: 30101810145250000974",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "БИК: 044525974",
          type: "body"
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(BaseTypography, {
          text: "АЛЬФА-БАНК",
          type: "body2"
        }),
        _createVNode(BaseTypography, {
          text: "Получатель: ООО «РВМ»",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "ОГРН: 1157847393373",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "ИНН: 7840042552 КПП: 780201001",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "Банковские реквизиты: Филиал «Санкт-Петербургский» АО «Альфа-Банк»",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "Р/с: 40702810532130016875",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "К/с: 30101810600000000786",
          type: "body"
        }),
        _createVNode(BaseTypography, {
          text: "БИК: 044030786",
          type: "body"
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(BaseTypography, {
          text: "ВОЗВРАТ ОПЛАТЫ",
          type: "body2"
        }),
        _createVNode(BaseTypography, {
          text: "Если у Вас появились причины для изменения условий Вашего бронирования или отмены тура, по Вашему заявлению вернём полную стоимость оплаченного Вами тура, или его часть, за вычетом фактически понесённых расходов и в зависимости от сроков отмены. Возврат рассматривается и рассчитывается индивидуально в каждом конкретном случае, в соответствии с условиями Вашего договора и условиями банка. Возврат переведённых денежных средств производится на Ваш банковский счёт в течении 5-30 рабочих дней (срок зависит от банка, который выдал Вам карту).",
          type: "body",
          tag: "p"
        })
      ])
    ])
  ]))
}
}

})